exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Video-module__video-player___1dIj9{border-radius:7px;overflow:hidden;padding-top:56.25%;width:100%;height:auto!important;position:relative;background-color:#000}.Video-module__video-player___1dIj9 .Video-module__video___3BeIx{width:100%;position:absolute;top:0;left:0;z-index:0}.Video-module__video-player___1dIj9 .Video-module__image___SVvi8{position:absolute;top:0;left:0;-o-object-fit:contain;object-fit:contain;-o-object-position:center;object-position:center;width:100%;height:100%;display:flex;align-items:center}", ""]);

// exports
exports.locals = {
	"video-player": "Video-module__video-player___1dIj9",
	"video": "Video-module__video___3BeIx",
	"image": "Video-module__image___SVvi8"
};